import PropTypes from "prop-types";
import React from "react";

import { DATE_FIELD_START } from "../../../constants/dateFields";
import dateWithTimestamp from "../../../modules/definition/calendar/dateFunctions/dateWithTimestamp";
import { PropTypeShapes } from "../../../types";
import FormDatePicker from "./FormDatePicker";

const SingleFormDatePicker = props => {
  const onBulkDateChange = value => {
    const { startDate } = value;
    props.onChange(dateWithTimestamp(props.calendar, startDate.timestamp, startDate.precision));
  };

  return (
    <FormDatePicker
      startDate={props.value}
      onStartDateChange={props.onChange}
      onBulkDateChange={onBulkDateChange}
      allowUncertainDates={false}
      selectedDateField={DATE_FIELD_START}
      calendar={props.calendar}
      disabled={props.disabled}
      validate={props.validate}
      autoFocus={props.autoFocus}
      hasCalendarPicker={props.hasCalendarPicker}
      onFocus={props.onFocus}
      onToggleCalendarPicker={props.onToggleCalendarPicker}
      title={props.title}
      backText={props.backText}
      targetId={props.targetId}
      useBackdrop={props.useBackdrop}
      startLabel={props.fieldLabel}
      emptyLabel={props.emptyLabel}
    />
  );
};

SingleFormDatePicker.propTypes = {
  value: PropTypeShapes.dateRelated,
  onChange: PropTypes.func,
  calendar: PropTypeShapes.calendar.isRequired,
  disabled: PropTypes.bool,
  validate: PropTypes.func,
  autoFocus: PropTypes.bool,
  hasCalendarPicker: PropTypes.bool,
  onFocus: PropTypes.func,
  onToggleCalendarPicker: PropTypes.func,
  title: PropTypes.string,
  fieldLabel: PropTypes.string,
  emptyLabel: PropTypes.string,
  backText: PropTypes.string,
  targetId: PropTypes.string,
  useBackdrop: PropTypes.bool
};

export default SingleFormDatePicker;
